import React, { useEffect, useState } from 'react'
import { Button, Card, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { useParams } from 'react-router'
import { actions as unitTestsActions } from '../../../../../store/reducers/unit-tests.reducer'
import { connect } from 'react-redux'
import Editor from '../../../../../components/common/Editor/Editor'
import Loading from '../../../../../components/loaders/Loading'
import Access from '../../../components/access/Access'
import { Perm, State } from '../../../../../constants/assignment-permissions'

const ReferenceSolution = ({ assignment, referenceSolution, fetchReferenceSolution, uploadReferenceSolution }) => {
    const { token } = useParams()

    const [isWaitingForUploadReferenceSolution, setIsWaitingForUploadReferenceSolution] = useState(false)

    useEffect(() => {
        fetchReferenceSolution(token)
    }, [])

    return (
        <Card
            title={`Reference solution${referenceSolution.name ? ` - ${referenceSolution.name}` : ''}`}
            className='unit-tests-section__reference-solution'
            extra={
                <Access rules={[Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED]}>
                    <Upload
                        showUploadList={false}
                        accept={'.' + assignment.language}
                        beforeUpload={async file => {
                            setIsWaitingForUploadReferenceSolution(true)
                            await uploadReferenceSolution(token, file)
                            setIsWaitingForUploadReferenceSolution(false)
                            return false
                        }}
                        aria-label='upload reference solution'
                    >
                        <Button loading={isWaitingForUploadReferenceSolution} aria-hidden='true' tabIndex={-1} data-test="upload-reference-solution-button">
                            <UploadOutlined aria-hidden='true' /> Upload Reference Solution
                        </Button>
                    </Upload>
                </Access>
            }
        >
            {referenceSolution.isWaiting ? (
                <Loading />
            ) : (
                <Editor value={referenceSolution.code} language={assignment.language} readOnly={true} />
            )}
        </Card>
    )
}

const mapState = ({ assignment, unitTests }) => {
    return {
        assignment: assignment.assignment,
        referenceSolution: unitTests.referenceSolution,
    }
}

const mapDispatch = dispatch => {
    return {
        fetchReferenceSolution: token => {
            return dispatch(unitTestsActions.fetchReferenceSolution(token))
        },
        uploadReferenceSolution: (token, file) => {
            return dispatch(unitTestsActions.uploadReferenceSolution(token, file))
        },
    }
}

export default connect(mapState, mapDispatch)(ReferenceSolution)
